<template>
  <div>
    <nav-breadcrumb :menu="[{label :'客户管理'},{label :'代客进件'}]"/>
    <panel label="渠道商信息">
      <form-build
        :form-data.sync="dataForm"
        :form-rules="dataFormRules1"
        :form-columns="dealerColumns"
        class="formTable"
        form-name="formSubmit3" ref="formBuildName3"

      />
    </panel>

    <panel label="客户信息">
      <form-build
        :form-data.sync="dataForm"
        :form-rules="dataFormRules"
        :form-columns="customerColumns"
        class="formTable"
        form-name="formSubmit1" ref="formBuildName1"
      />
    </panel>

    <panel>
      <el-checkbox true-label="true" false-label="false" label="共借人1" v-model="dataForm.coborrowers[0].co__checked"></el-checkbox>
      <form-build
        :form-data.sync="dataForm.coborrowers[0]"
        :form-rules="coRules"
        :form-columns="coColumns"
        class="formTable"
        form-name="coSubmit1" ref="coBuildName1"
        v-if="dataForm.coborrowers[0].co__checked=='true'"
      />
      <panel class="zhengjianxinxi"  v-if="dataForm.coborrowers[0].co__checked=='true'">
        <div class="zhenjianyyzz zhenjianyyzz2" >
          <image-upload  v-model="dataForm.coborrowers[0].co__borrowerICFront" prefix="images/"></image-upload>
          <label>本人身份证正面<span class="color-danger">*</span></label>
        </div>
        <div class="zhenjianyyzz zhenjianyyzz2" >
          <image-upload  v-model="dataForm.coborrowers[0].co__borrowerICBack" prefix="images/"></image-upload>
          <label>本人身份证反面<span class="color-danger">*</span></label>
        </div>
          <div class="zhenjianyyzz zhenjianyyzz2">
              <file-upload  v-model="dataForm.coborrowers[0].co__borrowerHukou1"></file-upload>
              <label>户口本</label>
          </div>
      </panel>
    </panel>
    <panel>
      <el-checkbox true-label="true" false-label="false" label="共借人2" v-model="dataForm.coborrowers[1].co__checked"></el-checkbox>
      <form-build
        :form-data.sync="dataForm.coborrowers[1]"
        :form-rules="coRules"
        :form-columns="coColumns"
        class="formTable"
        form-name="coSubmit2" ref="coBuildName2"
        v-if="dataForm.coborrowers[1].co__checked=='true'"
      />
      <panel class="zhengjianxinxi"  v-if="dataForm.coborrowers[1].co__checked=='true'">
        <div class="zhenjianyyzz zhenjianyyzz2"  v-if="dataForm.coborrowers[1].co__checked=='true'">
          <image-upload  v-model="dataForm.coborrowers[1].co__borrowerICFront" prefix="images/"></image-upload>
          <label>本人身份证正面<span class="color-danger">*</span></label>
        </div>
        <div class="zhenjianyyzz zhenjianyyzz2"  v-if="dataForm.coborrowers[1].co__checked=='true'">
          <image-upload  v-model="dataForm.coborrowers[1].co__borrowerICBack" prefix="images/"></image-upload>
          <label>本人身份证反面<span class="color-danger">*</span></label>
        </div>
          <div class="zhenjianyyzz zhenjianyyzz2">
              <file-upload  v-model="dataForm.coborrowers[1].co__borrowerHukou1"></file-upload>
              <label>户口本</label>
          </div>
      </panel>

    </panel>
    <panel>
      <el-checkbox true-label="true" false-label="false" label="共借人3" v-model="dataForm.coborrowers[2].co__checked"></el-checkbox>
      <form-build
        :form-data.sync="dataForm.coborrowers[2]"
        :form-rules="coRules"
        :form-columns="coColumns"
        class="formTable"
        form-name="coSubmit3" ref="coBuildName3"
        v-if="dataForm.coborrowers[2].co__checked=='true'"
      />
      <panel class="zhengjianxinxi"  v-if="dataForm.coborrowers[2].co__checked=='true'">
        <div class="zhenjianyyzz zhenjianyyzz2">
          <image-upload  v-model="dataForm.coborrowers[2].co__borrowerICFront" prefix="images/"></image-upload>
          <label>本人身份证正面<span class="color-danger">*</span></label>
        </div>
        <div class="zhenjianyyzz zhenjianyyzz2">
          <image-upload  v-model="dataForm.coborrowers[2].co__borrowerICBack" prefix="images/"></image-upload>
          <label>本人身份证反面<span class="color-danger">*</span></label>
        </div>
          <div class="zhenjianyyzz zhenjianyyzz2">
              <file-upload  v-model="dataForm.coborrowers[2].co__borrowerHukou1"></file-upload>
              <label>户口本</label>
          </div>
      </panel>

    </panel>
    <panel>
      <el-checkbox true-label="true" false-label="false" label="共借人4" v-model="dataForm.coborrowers[3].co__checked"></el-checkbox>
      <form-build
        :form-data.sync="dataForm.coborrowers[3]"
        :form-rules="coRules"
        :form-columns="coColumns"
        class="formTable"
        form-name="coSubmit4" ref="coBuildName4"
        v-if="dataForm.coborrowers[3].co__checked=='true'"
      />
      <panel class="zhengjianxinxi"  v-if="dataForm.coborrowers[3].co__checked=='true'">
        <div class="zhenjianyyzz zhenjianyyzz2">
          <image-upload  v-model="dataForm.coborrowers[3].co__borrowerICFront" prefix="images/"></image-upload>
          <label>本人身份证正面<span class="color-danger">*</span></label>
        </div>
        <div class="zhenjianyyzz zhenjianyyzz2">
          <image-upload  v-model="dataForm.coborrowers[3].co__borrowerICBack" prefix="images/"></image-upload>
          <label>本人身份证反面<span class="color-danger">*</span></label>
        </div>
          <div class="zhenjianyyzz zhenjianyyzz2">
              <file-upload  v-model="dataForm.coborrowers[3].co__borrowerHukou1"></file-upload>
              <label>户口本</label>
          </div>
      </panel>

    </panel>
    <panel>
      <el-checkbox true-label="true" false-label="false" label="共借人5" v-model="dataForm.coborrowers[4].co__checked"></el-checkbox>
      <form-build
        :form-data.sync="dataForm.coborrowers[4]"
        :form-rules="coRules"
        :form-columns="coColumns"
        class="formTable"
        form-name="coSubmit5" ref="coBuildName5"
        v-if="dataForm.coborrowers[4].co__checked=='true'"
      />
      <panel class="zhengjianxinxi"  v-if="dataForm.coborrowers[4].co__checked=='true'">
        <div class="zhenjianyyzz zhenjianyyzz2">
          <image-upload  v-model="dataForm.coborrowers[4].co__borrowerICFront" prefix="images/"></image-upload>
          <label>本人身份证正面<span class="color-danger">*</span></label>
        </div>
        <div class="zhenjianyyzz zhenjianyyzz2">
          <image-upload  v-model="dataForm.coborrowers[4].co__borrowerICBack" prefix="images/"></image-upload>
          <label>本人身份证反面<span class="color-danger">*</span></label>
        </div>
          <div class="zhenjianyyzz zhenjianyyzz2">
              <file-upload  v-model="dataForm.coborrowers[4].co__borrowerHukou1"></file-upload>
              <label>户口本</label>
          </div>
      </panel>

    </panel>
    <panel label="收款银行账户">
      <panel class="zhengjianxinxi">
      <el-checkbox true-label="true" false-label="false" label="暂时无法提供" v-model="dataForm.bank"></el-checkbox>
      <form-build
        :form-data.sync="dataForm"
        :form-rules="bankRules"
        :form-columns="bankColumns"
        class="formTable"
        form-name="formSubmit4" ref="formBuildName4"
      />
      </panel>
      <panel class="zhengjianxinxi">
        <div class="zhenjianyyzz zhenjianyyzz2" >
          <image-upload  v-model="dataForm.pic__customerBankCardFront" prefix="images/"></image-upload>
          <label>银行卡正面</label>
        </div>
      </panel>
    </panel>

    <panel label="抵押物信息">
        <div style="text-align: left;padding-top: 10px">
            <el-button type="primary" size="mini" @click="addData()">添加</el-button>
        </div>
        <panel  :label="'抵押物'+(idx+1)" v-for="(item, idx) in dataForm.properties" :key="idx" style="margin:10px">
          <form-build
            :form-data.sync="item"
            :form-rules="fangRules"
            :form-columns="fangColumns"
            class="formTable"
            form-name="formSubmit2" ref="formBuildName2"
          />

        <div class="zhenjianyyzz zhenjianyyzz2">
            <image-upload  v-model="item.pr__propertyCert" prefix="images/"></image-upload>
            <label>房产证<span class="color-danger">*</span></label>
        </div>
        <div class="zhenjianyyzz zhenjianyyzz2">
            <image-upload  v-model="item.pr__propertyLand" prefix="images/"></image-upload>
            <label>土地证</label>
        </div>
        <div class="zhenjianyyzz zhenjianyyzz2">
            <image-upload  v-model="item.pr__propertyLogbook" prefix="images/"></image-upload>
            <label>产调<span class="color-danger">*</span></label>
        </div>
            <div class="cb"></div>
        <div style="text-align: right;padding-top: 10px">
           <el-button type="primary" size="mini" @click="deleteData(idx)">删除</el-button>
        </div>
        </panel>
    </panel>
    <panel label="证件图片" class="zhengjianxinxi">
      <div class="zhenjianyyzz zhenjianyyzz2">
        <image-upload  v-model="dataForm.pic__customerICFront" prefix="images/"></image-upload>
        <label>本人身份证正面<span class="color-danger">*</span></label>
      </div>
      <div class="zhenjianyyzz zhenjianyyzz2">
        <image-upload  v-model="dataForm.pic__customerICBack" prefix="images/"></image-upload>
        <label>本人身份证反面<span class="color-danger">*</span></label>
      </div>
      <div class="zhenjianyyzz zhenjianyyzz2">
        <image-upload  v-model="dataForm.pic__customerHukou1" prefix="images/"></image-upload>
        <label>本人户口本主页<span class="color-danger">*</span></label>
      </div>
      <div class="zhenjianyyzz zhenjianyyzz2">
        <image-upload  v-model="dataForm.pic__customerHukou2" prefix="images/"></image-upload>
        <label>本人户口本<span class="color-danger">*</span></label>
      </div>
      <div class="zhenjianyyzz zhenjianyyzz2">
        <image-upload  v-model="dataForm.pic__marriageCert" prefix="images/"></image-upload>
        <label>结婚证明</label>
      </div>
      <div class="zhenjianyyzz zhenjianyyzz2">
        <image-upload  v-model="dataForm.pic__spouseICFront" prefix="images/"></image-upload>
        <label>配偶身份证正面</label>
      </div>
      <div class="zhenjianyyzz zhenjianyyzz2">
        <image-upload  v-model="dataForm.pic__spouseICBack" prefix="images/"></image-upload>
        <label>配偶身份证反面</label>
      </div>
      <div class="zhenjianyyzz zhenjianyyzz2">
        <image-upload  v-model="dataForm.pic__divorceCert" prefix="images/"></image-upload>
        <label>离婚证</label>
      </div>
      <div class="zhenjianyyzz zhenjianyyzz2">
        <image-upload  v-model="dataForm.pic__singleCert" prefix="images/"></image-upload>
        <label>单身证明</label>
      </div>
    </panel>
    <Panel label="银行流水和征信证明等附件">
      <div class="zhenjianyyzz zhenjianyyzz3">
        <file-upload  v-model="dataForm.att__bankStatement"></file-upload>
        <label>借款人银行流水</label>
      </div>
      <div class="zhenjianyyzz zhenjianyyzz3">
        <file-upload  v-model="dataForm.att__creditReport"></file-upload>
        <label>征信报告<span class="color-danger">*</span></label>
      </div>
    <div class="zhenjianyyzz zhenjianyyzz3">
        <file-upload  v-model="dataForm.pic__marriageCertII"></file-upload>
        <label>婚档</label>
    </div>
        <div class="zhenjianyyzz zhenjianyyzz3">
            <file-upload  v-model="dataForm.att__bizFile"></file-upload>
            <label>经营佐证</label>
        </div>
        <div class="zhenjianyyzz zhenjianyyzz3">
            <file-upload  v-model="dataForm.att__miscFile"></file-upload>
            <label>其他资料</label>
        </div>
    </Panel>
    <div class="tr xzmt">
      <el-button type="primary" @click="onSubmit()">提交</el-button>
      <!--<el-button  @click="onSubmit()">暂存</el-button>-->
    </div>
  </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import Panel from "../../components/Panel";
    import {getBirthByIC} from '../../utils/functions'

    export default {
        name: "CreateCustomer",
      components: {Panel},
      data(){
          return{
            unit:'',
            dialogVisible:false,
            form:{},
            formRules:{},
            productOptions:[],
            dataForm:{
              ba__productId:'',
              ba__interestType:'',
              ba__interestRate:'',
              bank:'true',
              coborrowers:[
                {
                  co__checked:'true',
                },
                {
                  co__checked:'false',
                },
                {
                  co__checked:'false',
                },
                {
                  co__checked:'false',
                },
                {
                  co__checked:'false',
                }
              ],
                properties:[
                    {
                        pr__checked:'true',
                    },
                ]
            },
            coRules:{
              co__relationship: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              co__borrowerName: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              co__borrowerIC: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              co__borrowerContactNo: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
            },
            coColumns:[
              {
                label: '与借款人关系',
                field: 'co__relationship',
                component: 'el-select',
                options:[
                  {
                    label:'配偶',
                    value:'配偶'
                  },
                  {
                    label:'父母',
                    value:'父母'
                  },
                  {
                    label:'兄弟',
                    value:'兄弟'
                  },
                  {
                    label:'姐妹',
                    value:'姐妹'
                  },
                  {
                    label:'子女',
                    value:'子女'
                  },
                  {
                    label:'朋友',
                    value:'朋友'
                  },
                  {
                    label:'其他',
                    value:'其他'
                  },
                ]
              },
              {
                label: '姓名',
                field: 'co__borrowerName',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '身份证号码',
                field: 'co__borrowerIC',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '手机号',
                field: 'co__borrowerContactNo',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '住所地址',
                field: 'co__borrowerAddress',
                component: 'el-input',
                type: 'text',
                span:24
              },
            ],
            dataFormRules1:{
              ba__dealerId: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],},
            bankRules: {
              ba__customerBankAccountNo: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ba__customerBankName: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
            },
            fangRules: {
              pr__propertyOwner: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
                pr__propertyLocation: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
                pr__propertyUsage: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
                pr__propertyArea: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
                pr__propertyCertNo: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              /*ex__propertyLandNo: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],*/
            },
            dataFormRules:{

              ba__customerName: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ba__customerIC: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ex__customerDOB: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ba__customerContactNo: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ex__customerSex: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ex__customerJiguan: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ex__customerHukou: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ex__customerAddress: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ex__customerMartialStatus: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ba__amount: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ba__productId: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
              ba__interestRate: [
                {
                  required: true,
                  message: '不能为空！',
                  trigger: 'blur'
                }
              ],
              ba__repaymentCount: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],
            },
            dealerOptions:[

            ],
            bankColumns:[
              {
                label: '户名',
                field: 'ba__customerName',
                type: 'text',
              },
              {
                label: '账号',
                field: 'ba__customerBankAccountNo',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '开户银行',
                field: 'ba__customerBankName',
                component: 'el-input',
                type: 'text',
                span:24
              },
            ],
            actions:[
              {
                label: '新增',
                class: 'el-icon-plus',
                clickHandler: ()=>{
                  this.editItem()
                }
              }
            ],
            fangColumns:[
              {
                label: '权属',
                field: 'pr__propertyOwner',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '位置',
                field: 'pr__propertyLocation',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '用途',
                field: 'pr__propertyUsage',
                component: 'el-select',
                options:[
                  {
                    label:'住宅（自建房）',
                    value:'住宅（自建房）'
                  },
                  {
                    label:'住宅（商品房）',
                    value:'住宅（商品房）'
                  },
                  {
                    label:'住宅（安置房）',
                    value:'住宅（安置房）'
                  },
                  {
                    label:'商用',
                    value:'商用'
                  },
                  {
                    label:'商住两用',
                    value:'商住两用'
                  }
                ]
              },
              {
                label: '面积',
                field: 'pr__propertyArea',
                component: 'el-input',
                type: 'number',
                props: {
                  step: 0.01
                },
                unit:'㎡'
              },
              {
                label: '产权证号',
                field: 'pr__propertyCertNo',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '土地证',
                field: 'pr__propertyLandNo',
                component: 'el-input',
                type: 'text',
              },
            ],
          }
      },
      computed: {
        customerColumns(){
            return [
              {
                label: '姓名',
                field: 'ba__customerName',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '身份证号码',
                field: 'ba__customerIC',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '出生日期',
                field: 'ex__customerDOB',
                component: 'el-date-picker',
                valueFormat: 'yyyy-MM-dd'
              },
              {
                label: '手机号',
                field: 'ba__customerContactNo',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '性别',
                field: 'ex__customerSex',
                component: 'el-select',
                options:[
                  {
                    label:'男',
                    value:'M'
                  },
                  {
                    label:'女',
                    value:'F'
                  }
                ]
              },
              {
                label: '籍贯',
                field: 'ex__customerJiguan',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '户口地区',
                field: 'ex__customerHukou',
                component: 'el-input',
                type: 'text',
                span:24
              },

              {
                label: '详细地址',
                field: 'ex__customerAddress',
                component: 'el-input',
                type: 'text',
                span:24
              },
              {
                label: '婚姻状况',
                field: 'ex__customerMartialStatus',
                component: 'el-select',
                options:[
                  {
                    label:'已婚',
                    value:'已婚'
                  },
                  {
                    label:'未婚',
                    value:'未婚'
                  },
                  {
                    label:'离异',
                    value:'离异'
                  },
                  {
                    label:'丧偶',
                    value:'丧偶'
                  }
                ]
              },
              {
                label: '配偶姓名',
                field: 'ex__spouseName',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '配偶身份证号码',
                field: 'ex__spouseIC',
                component: 'el-input',
                type: 'text',
              },
              {
                label: '配偶手机号',
                field: 'ex__spouseContactNo',
                component: 'el-input',
                type: 'text',
              },
                {
                    label: '配偶户口',
                    field: 'ex__spouseHukou',
                    component: 'el-input',
                    type: 'text',
                    span:24
                },
                {
                    label: '配偶生日',
                    field: 'ex__spouseDOB',
                    component: 'el-date-picker',
                    valueFormat: 'yyyy-MM-dd'
                },

                {
                    label: '配偶籍贯',
                    field: 'ex__spouseJiguan',
                    component: 'el-input',
                    type: 'text',
                },
              {
                label: '申贷金额',
                field: 'ba__amount',
                component: 'el-input',
                type: 'number',
                props: {
                  step: 0.01
                },
                span:12
              },
              {
                label: '贷款产品',
                field: 'ba__productId',
                component: 'el-select',
                options: this.productOptions,
              },
              {
                label: '贷款利率',
                field: 'ba__interestRate',
                component: 'el-input',
                type: 'number',
                props: {
                  step: 0.01
                },
                unit:this.unit

              },
              {
                label: '还款期数（月）',
                field: 'ba__repaymentCount',
                component: 'el-input',
                type: 'number',
              },
              {
                label: '贷款用途',
                field: 'ex__purpose',
                component: 'el-input',
                type:"textarea",
                span:24
              },
            ]

        },
        dialogTitle() {
          return this.form.cb__accountNo  ? '编辑账户' : '新增账户'
        },
        formColumns: {
          get() {
            return [
              {
                label: '与借款人关系',
                component: 'el-select',
                field: 'cb__accountNo',
                options:[
                  {
                    label:'',
                    value:''
                  },
                  {
                    label:'',
                    value:''
                  },
                  {
                    label:'',
                    value:''
                  },
                  {
                    label:'',
                    value:''
                  },
                  {
                    label:'',
                    value:''
                  }
                ],
                span: 24,
              },
              {
                label: '姓名',
                component: 'el-input',
                field: 'cb__accountName',
                span: 24,
              },
              {
                label: '身份证号',
                component: 'el-input',
                field: 'cb__accountName',
                span: 24,
              },
              {
                label: '手机号',
                component: 'el-input',
                field: 'cb__accountName',
                span: 24,
              },
              {
                label: '住址',
                component: 'el-input',
                field: 'cb__bank',
                type:'txteare',
                span: 24,
              }
            ]
          }
        },
        dealerColumns:{
          get(){
            return [
              {
                label: '渠道商名称',
                field: 'ba__dealerId',
                component: 'el-select',
                options:this.dealerOptions,
                span:24
              },
            ]
          }
        }

      },
      watch: {
        'dataForm.ba__customerIC' : function (newVal) {
          getBirthByIC(newVal) && this.$set(this.dataForm, 'ex__customerDOB', getBirthByIC(newVal))
        },
        'dataForm.ba__dealerId':function () {
          this.productOptions = []
          this.dataForm.ba__interestRate = ''
          this.unit = ''
          this.dataForm.ba__interestType = ''
          this.dataForm.ba__productName = ''
          this.dataForm.ba__productId = ''
          this.getFinanceProductFangList()
        },
        'dataForm.ba__productId':function (newVal) {

         // let lendingFee = (this.productOptions.filter(item=>item.value== newVal)[0]||{}).p__lendingFee
          let interestRate = (this.productOptions.filter(item => item.value == newVal)[0]||{}).dp__interestRate
         // let lendingFeeType = (this.productOptions.filter(item=>item.value== newVal)[0]||{}).p__lendingFeeType
          let interestType = (this.productOptions.filter(item=>item.value== newVal)[0]||{}).dp__interestType

          this.dataForm.ba__interestRate = interestRate
          this.dataForm.ba__productName = (this.productOptions.filter(item=>item.value== newVal)[0]||{}).p__productName

          if(interestType=='Yearly'){
            this.unit="%（年利率）"
          }
          if(interestType=='Daily'){
            this.unit="%（日利率）"
          }
          if(interestType=='Monthly'){
            this.unit="%（月利率）"
          }
          /*if(lendingFeeType=='Rate'){
            if(this.financingDetail.fi__totalAmount){
              this.financingDetail.fi__lendingFee = this.financingDetail.fi__totalAmount*lendingFee/100
            }
          }else{
            this.financingDetail.fi__lendingFee = lendingFee
          }*/
          this.dataForm.ba__interestType = interestType
        },
      },
      mounted() {
          this.getDealerList()
      },
      methods:{
          addData: function () {
              this.dataForm.properties.push({})
          },
          deleteData:function(index){
              this.dataForm.properties.splice(index, 1)
          },
        getDealerList: function () {
          xhr.getDealerList(
            Object.assign({pageSize:0}, {}, {}),
            res=> {
              try {
                this.dealerOptions = res.data.data.map(item=>{
                  return {
                    label: item.d__dealerName,
                    value:item.d__dealerId,
                  }
                })
              }catch(e){

              }
            })

        },
        getFinanceProductFangList: function () {
          xhr.getFinanceProductFangList(
            Object.assign({
              'd.dealerId':this.dataForm.ba__dealerId
            }, {}, {}),
            res=> {
              try {

                this.productOptions = res.data.data.map(item=>{
                  return {
                    label: item.p__productName,
                    value:item.p__productId,
                    'dp__interestRate':item.dp__interestRate,
                    'dp__interestType':item.dp__interestType,
                    'p__productName':item.p__productName,
                  }

                })
                //this.customerColumns[13].options = this.productOptions||[]
                //console.log( this.productOptions  )
              }catch(e){

              }
            })

        },
        onSubmit:function () {
          this.$refs.formBuildName1.$refs.formSubmit1.validate(valid1=> {
              if(valid1){
                  this.$refs.formBuildName3.$refs.formSubmit3.validate(valid3=> {

                      if(valid3){
                          if(!(this.dataForm.pic__customerICFront&&
                              this.dataForm.pic__customerICBack&&
                              this.dataForm.pic__customerHukou1&&
                              this.dataForm.att__creditReport&&
                              this.dataForm.pic__customerHukou2)){
                              this.$alert('有必填的图片未上传')
                              return false
                          }
                          let next = true
                          this.$refs.coBuildName1 && this.$refs.coBuildName1.$refs.coSubmit1.validate(valid4=> {
                              if (valid4) {
                                  if(!(this.dataForm.coborrowers[0].co__borrowerICFront&&this.dataForm.coborrowers[0].co__borrowerICBack)){
                                      this.$alert('共借人1有必填的图片未上传')
                                      next =  false
                                  }
                              }else{
                                  next =  false
                              }
                          })
                          this.$refs.coBuildName2 && this.$refs.coBuildName2.$refs.coSubmit2.validate(valid5=> {
                              if(!(this.dataForm.coborrowers[1].co__borrowerICFront&&this.dataForm.coborrowers[1].co__borrowerICBack)){
                                  this.$alert('共借人2有必填的图片未上传')
                                  next =  false
                              }
                              if (valid5) {
                              }else{
                                  next =  false
                              }
                          })

                          this.$refs.coBuildName3 && this.$refs.coBuildName3.$refs.coSubmit3.validate(valid6=> {
                              if (valid6) {
                                  if(!(this.dataForm.coborrowers[2].co__borrowerICFront&&this.dataForm.coborrowers[2].co__borrowerICBack)){
                                      this.$alert('共借人3有必填的图片未上传')
                                      next =  false
                                  }
                              }else{
                                  next =  false
                              }
                          })

                          this.$refs.coBuildName4 && this.$refs.coBuildName4.$refs.coSubmit4.validate(valid8=> {
                              if (valid8) {
                                  if(!(this.dataForm.coborrowers[3].co__borrowerICFront&&this.dataForm.coborrowers[3].co__borrowerICBack)){
                                      this.$alert('共借人4有必填的图片未上传')
                                      next =  false
                                  }
                              }else{
                                  next =  false
                              }
                          })

                          this.$refs.coBuildName5 && this.$refs.coBuildName5.$refs.coSubmit5.validate(valid9=> {
                              if (valid9) {
                                  if(!(this.dataForm.coborrowers[4].co__borrowerICFront&&this.dataForm.coborrowers[4].co__borrowerICBack)){
                                      this.$alert('共借人5有必填的图片未上传')
                                      next =  false
                                  }
                              }else{
                                  next =  false
                              }
                          })

                          if(!(this.dataForm.bank=='true')) {
                              this.$refs.formBuildName4.$refs.formSubmit4.validate(valid7 => {
                                  if (valid7) {

                                  } else {
                                      next = false
                                  }
                              })
                          }
                          let coborrower = true
                          let customerIC = this.dataForm.ba__customerIC
                          let customerContactNo = this.dataForm.ba__customerContactNo

                          let coborrowers = this.dataForm.coborrowers

                          for(var i=0;i<coborrowers.length;i++){
                              if(coborrowers[i].co__checked == 'true'){
                                  let ic= coborrowers[i].co__borrowerIC
                                  let no= coborrowers[i].co__borrowerContactNo
                                  if(customerIC==ic||customerContactNo ==no){
                                      coborrower  = false
                                  }
                                  if(i<coborrowers.length-1){
                                      for(var j=i+1;j<coborrowers.length;j++){
                                          if((coborrowers[j].co__borrowerIC==ic||coborrowers[j].co__borrowerContactNo ==no)&&coborrowers[j].co__checked == 'true'){
                                              coborrower  = false
                                          }
                                      }
                                  }
                              }
                          }


                          if(!coborrower){
                              this.$alert('存在重复的手机号或身份证号')
                          }

                          let proper = true
                          let properties = this.dataForm.properties

                          for(var i=0;i<properties.length;i++){
                              properties[i].pr__checked = true
                              let propertyOwner= properties[i].pr__propertyOwner
                              let propertyLocation= properties[i].pr__propertyLocation
                              let propertyUsage= properties[i].pr__propertyUsage
                              let propertyArea= properties[i].pr__propertyArea
                              let propertyCertNo= properties[i].pr__propertyCertNo
                              let propertyCert= properties[i].pr__propertyCert
                              let propertyLogbook= properties[i].pr__propertyLogbook
                              if(!(propertyOwner&&propertyLocation&&propertyUsage&&propertyArea&&propertyCertNo&&propertyCert&&propertyLogbook)){
                                  this.$alert('抵押物存在必填项未填写')
                                  proper = false
                              }

                              if(i<properties.length-1&&proper){
                                  for(var j=i+1;j<properties.length;j++){
                                      if(properties[j].pr__propertyLocation==propertyLocation){
                                          proper  = false
                                          this.$alert('抵押物'+(i+1)+'与抵押物'+(j+1)+'的位置不能重复')
                                      }
                                      if(properties[j].pr__propertyCertNo==propertyCertNo){
                                          proper  = false
                                          this.$alert('抵押物'+(i+1)+'与抵押物'+(j+1)+'的产权证号不能重复')
                                      }
                                  }
                              }

                          }

                          this.dataForm.t__checked = true
                          if(next&&coborrower&&proper){
                              xhr.createApplyingCustomerOffline(
                                  this.dataForm,
                                  res=> {
                                      try{
                                          if(res.data.status == 'success') {
                                              this.$router.push({
                                                  name: 'CustomerApplyingListFangView'
                                              })
                                          }else{
                                              this.$message.error(error.msgs[0].text)
                                          }
                                      }catch (e) {
                                          this.$message.error(error.msgs[0].text)

                                      }
                                  }
                              )
                          }
                      }
                  })
              }
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/CreateCustomer.vue